import { Shark, Utils } from "shark-mvc";
// import moment from "moment";
import $ from "jquery";


import templateContent from "../../_shark_templates/views/quotation-list.html";
import Quotation from "../../_shark_models/Quotation";
import ViewBase from "../../views/ViewBase";

import { activityReportComponent } from "../components/activityReportComponent";
import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import applicatorTeamManager from "../managers/applicatorTeamManager";
import contactDetailsModalComponent from "../../components/contactDetailsModal/contactDetailsModalComponent";
import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import followUpManager from "../managers/followUpManager";
import { clientManager } from "../managers/clientManager";
import { constructionSiteMultiDateComponent } from "../../components/constructionSiteMultiDate/constructionSiteMultiDateComponent";
import { dateRangeFilterComponent } from "../components/dateRangeFilter/dateRangeFilterComponent";
import followUpComponent from "../../components/followUp/followUpComponent";
import getMoreComponent from "../../components/getMore/getMoreComponent";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "Components/mainNavComponent";
import provinceFilterComponent from "../../_shark_components/provinceFilter/provinceFilterComponent";
import { quotationManager } from "../managers/quotationManager";
import { quotationActionsComponent } from "../../_shark_components/quotationActions/quotationActionsComponent";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import replaceQuotationAcceptDocumentComponent from "../../components/replaceQuotationAcceptDocument/replaceQuotationAcceptDocumentComponent";
import showAllContactsButtonComponent from "../../components/showAllContactsButton/showAllContactsButtonComponent";
import { siteInfoSheetActionsComponent } from "../../_shark_components/siteInfoSheetActions/siteInfoSheetActionsComponent";
import { siteInfoSheetManager } from "../managers/siteInfoSheetManager";
import { tableSorterComponent } from "../../_shark_components/tableSorter/tableSorterComponent";
import teamUpManager from "../managers/teamUpManager";
import { userManager } from "../managers/userManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class QuotationListView extends ViewBase {
	constructor(name) {
		super(name);

		this.setTemplate(templateContent);
	}

	afterComponentsPreRender () {
		let quotationList = Shark.get("quotationList");

		if (quotationList) {
			// const [agentFilter, dateRangeFilter, provinceFilter, quotationActiveFilters] = Shark.get(["agentFilter", "dateRangeFilter", "provinceFilter", "quotationActiveFilters"]);
			// let counter = 0;
			let showDateRangeInfo = false;

			quotationList.forEach((item, index) => {
				//Dave: Ecco, questo è il caso perfetto in cui il ModelRenderer dovrebbe fare il suo lavoro...
				if (!dateRangeFilterComponent.includeDate(item.__referenceDate) && dateRangeFilterComponent.includeDate(item.__updatedAt)) {
					item.__updatedAtDateLabel = "<span class=\"filter-matched-field-display\">" + item.__updatedAtLabel + "</span>";
					showDateRangeInfo = true;
				}
				else {
					item.__updatedAtDateLabel = item.__updatedAtLabel;
				}
				
				item.__render = true;
				item.__displayIndex = index + 1;
				item.__index = index;
				// counter++;
			});

			this.set({
				__showDateRangeInfo: showDateRangeInfo,
			});
			exportCSVComponent.set({
				listToExport: quotationList,
			});
			followUpComponent.set({
				sourceList: quotationList,
			});
	
			Shark.set({ activityReport: activityReportComponent.extractReport(quotationList) });
		}
	}

	afterLoad () {
		$(`[data-toggle="popover"]`).popover();
	}
	
	beforeLoad () {
		activityReportComponent.set("__reportType", "preventivi");
		liveSearchComponent.behavior = "database";
		liveSearchComponent.set({searchHint: "Il testo inserito verrà cercato nel nome del contatto, nel numero del preventivo, nella CCA."});
		followUpComponent.set("targetItem", null);
		constructionSiteMultiDateComponent.set("referenceListName", "quotationList");

		if (Shark.get("agentList").length === 0) {
			userManager.getList();
		}

		if (Shark.get("clientList").length === 0) {
			clientManager.getList();
		}	

		if (!Shark.get("applicatorTeamList") || Shark.get("applicatorTeamList").length === 0) {
			applicatorTeamManager.getList();
		}

		userManager.getRequireAttentionCounts();//Dave: Avremo le notifiche per aggiornare questi numeri

		if (Shark.get("quotationList").length === 0) {
			this.refreshList(null, true);
		}
		else {
			// Dave.Info: Se ho già una lista faccio un refresh "default" > carica solo se ci sono filtri diversi (es la provincia.)
			this.refreshList();
		}

		exportCSVComponent.set({
			savedFileBaseName: "Lista Preventivi",
			replaceMaps: {
				"siteInfoSheetType": {
					industrial: "Industriale",
					outdoor: "Outdoor",
				},
			},
			exportMap: {
				name: "Preventivi",
				id: "reportFieldMap",
				fields: {
					code: "Numero",
					revision: "Revisione",
					["extraData.confirmData.presumedAmount"]: "Importo stimato",
					__mq: "MQ",
					__referenceDateLabel: "Data",
					__sendingDateLabel: "Data invio",
					__statusLabel: "Stato",
					__acceptedUserLabel: "Accettato da",
					cca: "CCA",
					siteInfoSheetType: "Tipologia",
					__systemsLabel: "Sistemi",
					["extraData.confirmData.lotCount"]: "Lotti",
					__sendingDatePendingDays: "Giorni di attesa",
					__agentName: "Venditore",
					["contact.name"]: "Azienda",
					["contact.email"]: "eMail",
					["contact.phone"]: "Telefono",
					["siteInfoSheetData.clientCommoditySector"]: "Settore Merceologico",
					["siteInfoSheetRegistry.siteLocation.region"]: "Regione",
					["siteInfoSheetRegistry.siteLocation.province"]: "Provincia",
					["siteInfoSheetRegistry.siteLocation.address"]: "Indirizzo",
					["siteInfoSheetRegistry.siteLocation.city"]: "Città",
					latestFollowUp: "Ultimo Folllow up",
				}
			}
		});
	}
		
	beforeRender () {
		const hilitedQuotation = Shark.get("hilitedQuotation");
		const quotationList = Shark.get("quotationList");

		if (hilitedQuotation) {
			quotationList.forEach(item => item.__hilited = item.guid === hilitedQuotation.guid);
		}
	}

	beforeUnload () {
		Shark.set({
			hilitedQuotation: null
		});
	}

	cancelAcceptedStatusBtn_clickHandler (event, data) {
		//Dave: Questa roba va gestita con il menu "azioni" e unificata
		console.log({data});

		if (confirm("Attenzione!\nSe clicchi 'ok' il preventivo verrà riportato allo stato 'In attesa di riscontro' e perderai il documento di accettazione e gli altri dati impostati quando lo hai accettato.\n\nSe confermi non sarà possibile annullare!")) {
			if (confirm("Sei sicuro di voler procedere? Non potrai recuperare il documento di accettazione precedente!")) {
				const reason = prompt("Per favore inserisci una motivazione. (obbligatoria)");

				if (reason) {
					if (reason.trim() !== "") {
						const quotationList = Shark.get("quotationList");
						const currQuotation = Utils.safp(quotationList, "guid", data.guid);

						currQuotation.resetStatusToPending();
		
						quotationManager.save(currQuotation)
						.then(() => {
							const newFollowUp = Shark.getInstance("ClientFollowUp", {
								body: `Lo stato del Preventivo <q>${currQuotation.code}</q> è stato riportato a "In attesa di riscontro". È stata inserita la seguente motivazione: <q>${reason}</q>`,
								clientGuid: currQuotation.clientGuid,
								referenceGuid: currQuotation.guid,
								referenceType: "quotation",
								status: 3,
								type: "system"
							});
							console.log(newFollowUp);
					
							followUpManager.save(newFollowUp)
							.then(sharkResponse => {
								console.log({sharkResponse});
								this.refreshList();
							});
						});
					}
					else if (reason.trim() === "") {
						alert("La motivazione è obbligatoria, non posso procedere!");
					}
				}
				else if (reason.trim() === "") {
					alert("La motivazione è obbligatoria, non posso procedere!");
				}
			}
		}
	}

	getQuotationByGuid (guid) {
		const quotationList = Shark.get("quotationList");
		const currQuotation = Utils.safp(quotationList, "guid", guid);

		return currQuotation;
	}

	init () {
		this.addComponents([activityReportComponent, agentFilterComponent, constructionSiteMultiDateComponent, contactDetailsModalComponent, dateRangeFilterComponent, exportCSVComponent, followUpComponent, getMoreComponent, informationModalComponent, liveSearchComponent, mainNavComponent, provinceFilterComponent, quotationActionsComponent, refreshListButtonComponent, replaceQuotationAcceptDocumentComponent, showAllContactsButtonComponent, siteInfoSheetActionsComponent, tableSorterComponent, waitBoxComponent]);

		const filtersStatus = this.getFiltersStatus();

		const quotationActiveFilters = Shark.getInstance("__smart__", {
			acceptedCount: 0,
			cscCreatedCount: 0,
			csClosedCount: 0,
			cscNotCreatedCount: 0,
			pendingCount: 0,
			refusedCount: 0,
			showAccepted: filtersStatus ? filtersStatus.showAccepted : false,
			showCSCCreated: filtersStatus ? filtersStatus.showCSCCreated : false,
			showCSClosed: filtersStatus ? filtersStatus.showCSClosed : false,
			showCSCNotCreated: filtersStatus ? filtersStatus.showCSCNotCreated : true,
			showCSRunning: filtersStatus ? filtersStatus.showCSRunning : true,
			showPending: filtersStatus ? filtersStatus.showPending : true,
			showRefused: filtersStatus ? filtersStatus.showRefused : false,
			showUploaded: filtersStatus ? filtersStatus.showUploaded : true,
			showWaiting: filtersStatus ? filtersStatus.showWaiting : true,
			uploadedCount: 0,
			__showAcceptedSubFilters: filtersStatus ? filtersStatus.showAccepted : false,
		});

		quotationActiveFilters.on("dataChanged", function () {
			console.log("datachaged", this);
			quotationListView.saveFiltersStatus(this);
			this.__showAcceptedSubFilters = this.showAccepted;

			if ((this.showAccepted && (this.showCSCCreated || this.showCSClosed || this.showCSRunning || this.showCSCNotCreated)) || this.showCSCCreated || this.showCSClosed || this.showCSCNotCreated || this.showPending || this.showRefused || this.showUploaded || this.showWaiting) {
				quotationListView.refreshList();
			}
			else {
				Shark.set({
					quotationList: [],
				});
				Shark.render();
			}
		});

		Shark.set({
			agentList: Shark.get("agentList") || [],
			clientList: Shark.get("clientList") || [],
			quotationList: Shark.get("quotationList") || [],
			quotationActiveFilters,
		});

		this.set({
			__htmlTitle: "Lista Preventivi | IPM HUB",
		});

		getMoreComponent.views[this.className] = {
			currentPage: 0,
		};
	}

	prepareSingleDataSetExport () {
		console.log();
		waitBoxComponent.open();

		return new Promise((resolve) => {
			const { quotationList } = Shark.get();
			const guidList = quotationList.map(item => item.guid);

			quotationManager.getListByGuidList(guidList, { getFullContacts: true })
			.then(getResponse => {
				console.log({getResponse});
				const quotationListToExport = Shark.getInstanceList(Quotation, getResponse.data);
					
				waitBoxComponent.close();
				resolve(quotationListToExport);
			});
		});
	}

	quotationActionBtn_clickHandler (event, data) {
		const currQuotation = this.getQuotationByGuid(data.guid);

		if (currQuotation) {
			switch(data.action) {
				case "delete":
					if (confirm("Sei sicuro di voler eliminare il Preventivo selezionato?\n\nSe procedi non potrai annullare e la relativa Scheda Informativa verrà riportata allo stato 'In attesa di preventivo'!")) {
						const reason = prompt("Per favore indica un motivo per questa cancellazione");

						waitBoxComponent.open();

						quotationManager.delete(currQuotation, true, reason || "")
						.then(() => {
							waitBoxComponent.close();
							this.refreshList();
						});
					}
					break;
				case "revertStatusToPending":
					if (currQuotation.status !== Quotation.STATUS_REFUSED) {
						alert("Mi spiace, al momento questa funzionalità è disponibile solo per i Preventivi rifiutati!");
						return;
					}
					if (confirm("Sei sicuro di voler riportare il Preventivo allo status 'In attesa di riscontro dal cliente'?\n\nSe procedi non potrai annullare!")) {
						const reason = prompt("Per favore indica un motivo per questa modifica");

						waitBoxComponent.open();

						quotationManager.revertStatus(currQuotation, Quotation.STATUS_PENDING, reason || "")
						.then(() => {
							waitBoxComponent.close();
							this.refreshList();
						});
					}
					break;
			}
		}
	}

	refreshList (range = null, force = false) {
		waitBoxComponent.show();
		Shark.set({hilitedQuotation: null});

		let incrementalRequest = false;

		if (!range) {
			getMoreComponent.views[this.className] = {
				currentPage: 0,
			};
			range = getMoreComponent.getCurrentPageRangeForView(this.className);
		}
		else {
			incrementalRequest = true;
		}

		const { agentFilter, dateRangeFilter, provinceFilter, quotationActiveFilters } = Shark.get();
		const filters = quotationActiveFilters.export();

		delete filters.acceptedCount;
		delete filters.cscCreatedCount;
		delete filters.csClosedCount;
		delete filters.cscNotCreatedCount;
		delete filters.pendingCount;
		delete filters.refusedCount;
		delete filters.uploadedCount;

		if (provinceFilter.province !== "all") {
			filters.province = provinceFilter.province;
		}

		if (agentFilter.agentGuid !== "") {
			filters.agentGuid = agentFilter.agentGuid;
		}

		if (!dateRangeFilter.ignoreDateRange) {
			filters.dateFrom = dateRangeFilter.__from;
			filters.dateTo = dateRangeFilter.__to;
		}

		if (this.textFilters) {
			Object.assign(filters, this.textFilters);
		}

		// Dave.ToDo: Portare tutto in una funzione, lo faccio ovunque!
		if (!force) {
			if (localStorage.quotationListViewLastFilters) {
				if (localStorage.quotationListViewLastFilters === JSON.stringify({filters, range})) {
					refreshListButtonComponent.resetStatus();
					waitBoxComponent.hide();
					return;
				}
			}
		}

		return quotationManager.getFilteredList({filters, range, incrementalRequest})
		.then(response => {
			localStorage.quotationListViewLastFilters = JSON.stringify({filters, range});

			const provinceForFilterComponentSet = new Set();
			response.data.forEach(item => provinceForFilterComponentSet.add(item.siteInfoSheetData.clientProvince));

			let provinceForFilterComponent = Array.from(provinceForFilterComponentSet);
			provinceForFilterComponent.sort();
			provinceForFilterComponent = provinceForFilterComponent.map(item => item.trim() !== "" ? {label: item, value: item} : {label: "- Non impostata", value: ""});

			waitBoxComponent.hide();

			Shark.set({provinceForFilterComponent});
			Shark.render();
		});
	}

	
	showQuotationConfirmationBtn_clickHandler (event, data) {
		const quotationList = Shark.get("quotationList");
		const currQuotation = Utils.safp(quotationList, "guid", data.guid);

		if (currQuotation) {
			if (currQuotation?.extraData?.confirmData?.builtPDFURL && currQuotation.extraData.confirmData.builtPDFURL.trim() !== "") {
				window.open(`${Shark.get("__cdnURL")}/${currQuotation.extraData.confirmData.builtPDFURL.trim()}`, "_blank");
			}
			else {
				const pictures = currQuotation.extraData.confirmData.pictures;
				window.open(`${Shark.get("__cdnURL")}/${pictures[pictures.length - 1].url}`, "_blank");
			}
		}
	}

	showQuotationInfoBtn_clickHandler (event, data) {
		const quotationList = Shark.get("quotationList");
		const currQuotation = Utils.safp(quotationList, "guid", data.guid);

		let message = `<strong>Numero Preventivo</strong>: ${currQuotation.code}
		<br><strong>Data Preventivo</strong>: ${currQuotation.__referenceDateLabel}
		<br><strong>Stato</strong>: ${currQuotation.__statusLabel} ${currQuotation.__status_refused && currQuotation.extraData.refuseReason !== "" ? "(Motivazione: " + currQuotation.extraData.refuseReason + ")" : ""}
		${currQuotation.__acceptedUserLabel !== "" ? "<br>Segnato " + (currQuotation.__status_refused ? "Rifiutato" : "Accettato") + " da " + currQuotation.__acceptedUserLabel : ""}
		<br><br><strong>Importo Presunto</strong>: ${currQuotation.extraData.confirmData.presumedAmount > 0 ? currQuotation.__presumedAmountLabel : "N/D"}
		<br><br><strong>Condizioni</strong>: ${currQuotation.extraData.confirmData.conditions ? currQuotation.extraData.confirmData.conditions.replace(/\n/g, "<br>") : "N/D"}
		<br><br><strong>Lotti</strong>: ${currQuotation.lots.length}
		<br><strong>Lotti con Scheda Cantiere</strong>: ${currQuotation.__lotsCSCCreated}
		<br><br><strong>CCA</strong>: ${currQuotation.cca ? currQuotation.cca : "N/D"}
		<br><strong>Data Invio</strong>: ${currQuotation.__sendingDateLabel}
		`;

		if (currQuotation.cca.trim() !== "") {
			waitBoxComponent.show();
			
			teamUpManager.getEventByCCA(currQuotation.cca)
			.then(teamUpResponse => {
				if (teamUpResponse.status === "ok") {
					message += `<hr>`;
					if (teamUpResponse.data.constructionApplicatorTeam && teamUpResponse.data.constructionApplicatorTeam.trim() !== "") {
						message += `<strong>Squadra</strong>: ${teamUpResponse.data.constructionApplicatorTeam}`;
					}
					message += `<br><strong>Inizio cantiere</strong>: ${teamUpResponse.data.constructionStartDate}
					<br><strong>Fine cantiere</strong>: ${teamUpResponse.data.constructionEndDate}`;
				}

				waitBoxComponent.hide();
				setTimeout(() => {
					informationModalComponent.show({body: message, title: "Informazioni sul preventivo"});
				}, 200);
			});
		}
		else {
			if (currQuotation) {
				informationModalComponent.show({body: message, title: "Informazioni sul preventivo"});
			}
		}
	}

	updateTextFilters (searchKey) {
		if (searchKey && searchKey !== "") {
			this.textFilters = {
				cca: searchKey,
				clientName: searchKey,
				code: searchKey,
				searchKey,
			};
		}
		else {
			this.textFilters = null;
		}

		this.refreshList()
		.then(() => {
			if (searchKey !== "") {
				liveSearchComponent.setFocus();
			}
		});
	}







	
	addQuotationBtn_clickHandler (event, data) {
		const quotationList = Shark.get("quotationList");
		const currQuotation = Utils.safp(quotationList, "guid", data.guid);

		Shark.set({currQuotation});

		if (currQuotation && confirm("Vuoi inviare una nuova revisione per questo Preventivo?")) {
			Shark.set({newRevisionQuotation: currQuotation});

			siteInfoSheetManager.getByGuid(currQuotation.siteInfoSheetGuid)
			.then(sharkResponse => {
				if (sharkResponse.status === "ok") {
					Shark.set({currSiteInfoSheet: sharkResponse.data});
					let newCode = currQuotation.code;
					const revIndex = newCode.indexOf("REV.");
					let newRevisionNumber = 0;

					if (revIndex > -1) {
						newRevisionNumber = parseInt(newCode.substr(revIndex + 5, 2));

						if (!isNaN(newRevisionNumber)) {
							newRevisionNumber++;
							newCode = newCode.substr(0, revIndex) + "REV." + Utils.zeroFill(newRevisionNumber, 2);
						}
					}
					else {
						newCode += " REV.01";
						newRevisionNumber = 1;
					}

					siteInfoSheetActionsComponent.show("", newCode, currQuotation);
					console.log("addQuotationBtn_clickHandler > response", currQuotation, sharkResponse.data);
				}
			});
		}
	}

	setAsAcceptedBtn_clickHandler (event, data) {
		const quotationList = Shark.get("quotationList");
		const currQuotation = Utils.safp(quotationList, "guid", data.guid);

		if (currQuotation) {
			Shark.set({currQuotation});
			quotationActionsComponent.show("accept");
		}
	}

	setAsRefusedBtn_clickHandler (event, data) {
		const quotationList = Shark.get("quotationList");
		const currQuotation = Utils.safp(quotationList, "guid", data.guid);

		if (currQuotation) {
			Shark.set({currQuotation});
			quotationActionsComponent.show("refuse");
		}
	}

	//DAve: Non gestiamo più le CCA lato Quotation ma solo lato CSC
	// setCCACodeBtn_clickHandler (event, data) {
	// 	const quotationList = Shark.get("quotationList");
	// 	const currQuotation = Utils.safp(quotationList, "guid", data.guid);

	// 	if (currQuotation) {
	// 		Shark.set({currQuotation});
	// 		quotationActionsComponent.show("cca");
	// 	}
	// });

	async setStatusAutomaticBtn_clickHandler (event, data) {
		await quotationManager.setStatusAutomatic({guid: data.guid});
		this.refreshList(null, true);
	}

	siteInfoSheetManager_savedHandler () {
		Shark.render();
	}

}

const quotationListView = new QuotationListView("quotationListView");

Shark.registerView(quotationListView);

export default quotationListView;
